import { useSelector } from 'react-redux';
import { RootState } from 'src/actions/configuration/rootReducer';

const useAppFeatures = () => useSelector((state: RootState) => state.appFeatures.value);
export default useAppFeatures;
